import { UppFloorPlanBar } from '../../floor-plan-element';
import type { FloorPlanAreaSourceDrawPieceItem, UppKonvaShape } from '../floor-plan-wire-types';
import type { UppFloorPlanBarShape } from '../../floor-plan-element';
import { elementOptsFromLabels } from './shape-bridge-helpers';
import type { FloorPlanShapeBridge, SourceToWireInput } from './shape-bridge-types';

function adapterRowLabels(row: UppKonvaShape): {
  label?: string;
  sublabel?: string;
  zIndex?: number;
  custom?: unknown;
} {
  const o: { label?: string; sublabel?: string; zIndex?: number; custom?: unknown } = {};
  if ('label' in row && row.label !== undefined) {
    o.label = row.label;
  }
  if ('sublabel' in row && row.sublabel !== undefined) {
    o.sublabel = row.sublabel;
  }
  if ('zIndex' in row && row.zIndex !== undefined) {
    o.zIndex = row.zIndex;
  }
  if (Object.prototype.hasOwnProperty.call(row, 'custom')) {
    o.custom = (row as { custom?: unknown }).custom;
  }
  return o;
}

export const barShapeBridge: FloorPlanShapeBridge = {
  kind: 'BAR',
  wireType: 'BAR',
  sourceToWire(i: SourceToWireInput): UppKonvaShape {
    const p: FloorPlanAreaSourceDrawPieceItem = {
      type: 'BAR',
      x: i.x,
      y: i.y,
      width: i.width,
      height: i.height,
      rotation: i.rotation,
      shape: String(i.d['shape'] ?? 'LINEAR'),
      ...(typeof i.d['stoolLeft'] === 'number' ? { stoolLeft: i.d['stoolLeft'] as number } : {}),
      ...(typeof i.d['stoolRight'] === 'number' ? { stoolRight: i.d['stoolRight'] as number } : {}),
      ...(typeof i.d['stoolFront'] === 'number' ? { stoolFront: i.d['stoolFront'] as number } : {}),
      ...(i.id.uuid ? { uuid: i.id.uuid } : {}),
      ...i.lb,
    };
    return { ...p, ...(!i.id.uuid ? { id: i.id.id } : {}) } as UppKonvaShape;
  },
  wireToSource(row: UppKonvaShape) {
    const r = row as FloorPlanAreaSourceDrawPieceItem;
    const uuid = r.uuid !== undefined && r.uuid.trim() !== '' ? r.uuid.trim() : '';
    const legacyId = 'id' in row && typeof (row as { id?: unknown }).id === 'string' ? String((row as { id: string }).id) : '';
    const id = uuid || legacyId || 'shape-BAR';
    const base = {
      id,
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height,
      rotation: r.rotation,
      ...adapterRowLabels(row),
    };
    return {
      ...base,
      kind: 'BAR',
      data: {
        shape: r.shape ?? 'LINEAR',
        ...(r.stoolLeft !== undefined ? { stoolLeft: r.stoolLeft } : {}),
        ...(r.stoolRight !== undefined ? { stoolRight: r.stoolRight } : {}),
        ...(r.stoolFront !== undefined ? { stoolFront: r.stoolFront } : {}),
      },
    };
  },
  wireToElement(row: UppKonvaShape, uuid: string) {
    const r = row as FloorPlanAreaSourceDrawPieceItem;
    const { x, y, width, height, rotation } = r;
    const opt = elementOptsFromLabels(r, false);
    const el = new UppFloorPlanBar(
      uuid,
      x,
      y,
      width,
      height,
      rotation,
      (r.shape as UppFloorPlanBarShape | undefined) ?? 'LINEAR',
      r.stoolLeft,
      r.stoolFront,
      r.stoolRight,
      opt,
    );
    el.zIndex = r.zIndex ?? 0;
    return el;
  },
};
